module.exports = __webpack_public_path__ + "img/frame (37).37d8a5e1.jpg";